module.exports = __webpack_public_path__ + "static/media/yokoFukkin.f9fed183.png";